/* ArtGold Finance — accordion behavior + smooth anchor scroll */
(function () {
  'use strict';

  function initAccordions(scope) {
    var root = scope || document;
    var triggers = root.querySelectorAll('.agfi-accordion__trigger');
    Array.prototype.forEach.call(triggers, function (trigger) {
      if (trigger.dataset.agfiBound === '1') return;
      trigger.dataset.agfiBound = '1';
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var panelId = trigger.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (panel) {
          if (expanded) panel.classList.remove('is-open');
          else panel.classList.add('is-open');
        }
      });
    });
  }

  function initAnchors() {
    var links = document.querySelectorAll('a[href^="#"]');
    Array.prototype.forEach.call(links, function (link) {
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Move focus for accessibility
        var prevTab = target.getAttribute('tabindex');
        if (prevTab === null) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAccordions();
      initAnchors();
    });
  } else {
    initAccordions();
    initAnchors();
  }
})();
